import  request  from "../utils/xwwwrequest";
let base64 = require('js-base64').Base64;
// http://36.24.154.157:12000/captcha  
//nk/choose/user/leftResource 获取登录用户左侧菜单栏
export function leftResource(params){
    return request({
        method:'GET',
        url:'/nk/choose/user/leftResource',
        params:params
        // data:data,
        // headers:{
        //     Authorization:'Basic'+" "+base64.encode("spx-web-client_id:123456")
        // }
    })
} 
///nk/choose/user/userDetail 获取用户详情
export function userDetail(params){
    return request({
        method:'GET',
        url:'/nk/choose/user/userDetail',
        params:params
    })
}

//nk/choose/user/deleteUser 删除用户信息
export function deleteUser(params){
    return request({
        method:'GET',
        url:'/nk/choose/user/deleteUser',
        params:params
    })
}
//nk/choose/role/list 获取角色列表信息
export function hqjsbfylist(params){
    return request({
        method:'GET',
        url:'/nk/choose/role/list',
        params:params
    })
}

//nk/choose/role/detail 获取角色详情
export function hqjsxqdetail(params){
    return request({
        method:'GET',
        url:'/nk/choose/role/detail',
        params:params
    })
}

// 删除 /nk/choose/role/delete{id}
export function Deledelete(params){
        return request({
                url:'/nk/choose/role/delete/',
                method:'DELETE',
        params:params
        })
}

// 删除 /nk/choose/role/getBindMenu
export function getBindMenu(params){
	return request({
        method:'GET',
        url:'/nk/choose/role/getBindMenu',
        params:params
	})
}

// 获取所有的菜单信息[非当前用户的] /nk/choose/role/resource
export function fdqyhresource(params){
	return request({
        method:'GET',
        url:'/nk/choose/role/resource',
        params:params
	})
}

// 获取所有的菜单信息[非当前用户的] /nk/choose/role/deleteMenuShip
export function deleteMenuShip(params){
	return request({
        method:'GET',
        url:'/nk/choose/role/deleteMenuShip',
        params:params
	})
}

//nk/choose/product/specifications/specificationCate
export function specificationCate(params){
	return request({
        method:'GET',
        url:'/nk/choose/product/specifications/specificationCate',
        params:params
	})
}

//nk/choose/product/specifications/deleteSpecCate
export function deleteSpecCate(params){
	return request({
        method:'GET',
        url:'/nk/choose/product/specifications/deleteSpecCate',
        params:params
	})
}

//nk/choose/product/specifications/specificationsDetail
export function specificationsDetail(params){
	return request({
        method:'GET',
        url:'/nk/choose/product/specifications/specificationsDetail',
        params:params
	})
}

//nk/choose/product/specifications/deleteSpecificationValue
export function deleteSpecificationValue(params){
	return request({
        method:'GET',
        url:'/nk/choose/product/specifications/deleteSpecificationValue',
        params:params
	})
}

//nk/choose/product/specifications/deleteSpecification
export function deleteication(params){
	return request({
        method:'GET',
        url:'/nk/choose/product/specifications/deleteSpecification',
        params:params
	})
}

//nk/choose/product/parts/partsList
export function partsList(params){
	return request({
        method:'GET',
        url:'/nk/choose/product/parts/partsList',
        params:params
	})
}

//nk/choose/product/parts/deletePartCate
export function deletePartCate(params){
	return request({
        method:'GET',
        url:'/nk/choose/product/parts/deletePartCate',
        params:params
	})
}


//nk/choose/product/parts/deleteParts
export function deleteParts(params){
	return request({
        method:'GET',
        url:'/nk/choose/product/parts/deleteParts',
        params:params
	})
}

//nk/choose/product/parts/partDetail
export function deletepartDetail(params){
	return request({
        method:'GET',
        url:'/nk/choose/product/parts/partDetail',
        params:params
	})
}
//nk/choose/product/parts/deletePartsVariants
export function deletePartsVariants(params){
	return request({
        method:'GET',
        url:'/nk/choose/product/parts/deletePartsVariants',
        params:params
	})
}

//nk/choose/marketing/guidance/queryDetail
export function ydyscqueryDetail(params){
	return request({
        method:'GET',
        url:'/nk/choose/marketing/guidance/queryDetail',
        params:params
	})
}

// 删除引导语 /nk/choose/marketing/guidance/delete
export function ydydelete(params){
        return request({
        url:'/nk/choose/marketing/guidance/delete',
        method:'DELETE',
        params:params
        })
}

// 获取公告详情 /nk/choose/marketing/subject/detail
export function hqggxqdetail(params){
	return request({
        method:'GET',
        url:'/nk/choose/marketing/subject/detail',
        params:params
	})
}

// 删除公告 /nk/choose/marketing/subject/delete
export function ggdelete(params){
        return request({
        url:'/nk/choose/marketing/subject/delete',
        method:'DELETE',
        params:params
        })
}

// 删除产品类别 /nk/choose/product/category/deleteCate
export function deleteCate(params){
	return request({
        method:'GET',
        url:'/nk/choose/product/category/deleteCate',
        params:params
	})
}

// 获取产品类别详情 /nk/choose/product/category/detail
export function cplbdetail(params){
	return request({
        method:'GET',
        url:'/nk/choose/product/category/detail',
        params:params
	})
}

// 获取产品类别详情 /nk/choose/product/category/queryCateType
export function queryCateType(params){
	return request({
        method:'GET',
        url:'/nk/choose/product/category/queryCateType',
        params:params
	})
}

// 配件参数类型列表 /nk/choose/product/partsList
export function pjcslbpartsList(params){
	return request({
        method:'GET',
        url:'/nk/choose/product/partsList',
        params:params
	})
}

// 查询配件信息列表 /nk/choose/product/queryParts
export function queryPartsList(params){
	return request({
        method:'GET',
        url:'/nk/choose/product/queryParts',
        params:params
	})
}

// 获取海报详情 /nk/choose/marketing/poster/detail
export function hbxqdetail(params){
	return request({
        method:'GET',
        url:'/nk/choose/marketing/poster/detail',
        params:params
	})
}

// 删除海报 /nk/choose/marketing/poster/delete
export function hbscdelete(params){
	return request({
        method:'GET',
        url:'/nk/choose/marketing/poster/delete',
        params:params
	})
}

// 删除轮播 /nk/choose/marketing/carousel/deleteCarousel
export function deleteCarousel(params){
	return request({
        method:'GET',
        url:'/nk/choose/marketing/carousel/deleteCarousel',
        params:params
	})
}

// 获取轮播图详情 /nk/choose/marketing/carousel/detail
export function hqlbtxqdetail(params){
	return request({
        method:'GET',
        url:'/nk/choose/marketing/carousel/detail',
        params:params
	})
}

// 获取订单详情 /nk/choose/order/orderDetail
export function orderDetail(params){
	return request({
        method:'GET',
        url:'/nk/choose/order/orderDetail',
        params:params
	})
}

// 删除订单 /nk/choose/order/delete
export function dddelete(params){
        return request({
        url:'/nk/choose/order/delete',
        method:'DELETE',
        params:params
        })
}

// 获取首页数据信息 /nk/choose/home/index
export function hqsyxxindex(params){
        return request({
        method:'GET',
        url:'/nk/choose/home/index',
        params:params
        })
}

// 下单趋势统计 /nk/choose/home/place-order
export function placeorder(params){
        return request({
        method:'GET',
        url:'/nk/choose/home/place-order',
        params:params
        })
}

// 产品种类销售数据 /nk/choose/home/saleCate
export function xssjsaleCate(params){
        return request({
        method:'GET',
        url:'/nk/choose/home/saleCate',
        params:params
        })
}

// 删除当前产品 /nk/choose/product/expurgate
export function expurgate(params){
        return request({
        url:'/nk/choose/product/expurgate',
        method:'DELETE',
        params:params
        })
}

// 查询产品配件信息 /nk/choose/product/queryProductParts
export function queryProductParts(params){
        return request({
        method:'GET',
        url:'/nk/choose/product/queryProductParts',
        params:params
        })
}

// 获取产品详情 /nk/choose/product/detail
export function hqcpxqdetail(params){
        return request({
        method:'GET',
        url:'/nk/choose/product/detail',
        params:params
        })
}
// 删除当前产品和配件 /nk/choose/product/sold/expurgate
export function sccphpjexpurgate(params){
        return request({
        url:'/nk/choose/product/sold/expurgate',
        method:'DELETE',
        params:params
        })
}
// 获取产品详情---goodsType为0的时候，走这个接口 /nk/choose/product/sold/detail
export function xjcpxqdetail(params){
        return request({
        method:'GET',
        url:'/nk/choose/product/sold/detail',
        params:params
        })
}

// 获取配件详情页---goodsType为1的时候，走这个接口 /nk/choose/product/sold/partDetail
export function xjpjxqpartDetail(params){
        return request({
        method:'GET',
        url:'/nk/choose/product/sold/partDetail',
        params:params
        })
}

// 删除产品规格 /nk/choose/product/expurgateProductVariants
export function expurgateProductVariants(params){
        return request({
        method:'GET',
        url:'/nk/choose/product/expurgateProductVariants',
        params:params
        })
}

// 查询级联配件信息 /nk/choose/product/queryCascadeParts
export function queryCascadeParts(params){
        return request({
        method:'GET',
        url:'/nk/choose/product/queryCascadeParts',
        params:params
        })
}

// 移除商品主图片 /nk/choose/product/removeImage
export function ycremoveImage(params){
        return request({
        method:'GET',
        url:'/nk/choose/product/removeImage',
        params:params
        })
}

// 移除配件主图片 /nk/choose/product/parts/removeImage
export function pjycremoveImage(params){
        return request({
        method:'GET',
        url:'/nk/choose/product/parts/removeImage',
        params:params
        })
}

// 删除文件 /nk/choose/file/removeFile
export function scwjremoveFile(params){
        return request({
        method:'GET',
        url:'/nk/choose/file/removeFile',
        params:params
        })
}

// 下拉获取用户信息 /nk/choose/queryUser
export function xlhqhqueryUser(params){
        return request({
        method:'GET',
        url:'/nk/choose/queryUser',
        params:params
        })
}

// 获取省市区划 /nk/choose/list
export function hqssqlist(params){
        return request({
        method:'GET',
        url:'/nk/choose/list',
        params:params
        })
}

// 删除业务区域 /nk/choose/deleteRegional
export function deleteRegional(params){
        return request({
        method:'GET',
        url:'/nk/choose/deleteRegional',
        params:params
        })
}

// 获取业务区域详情 /nk/choose/detail
export function hqywqyxqdetail(params){
        return request({
        method:'GET',
        url:'/nk/choose/detail',
        params:params
        })
}

// 加载首页最新未读消息列表 /nk/choose/home/selectUnReadMessage
export function selectUnReadMessage(params){
        return request({
        method:'GET',
        url:'/nk/choose/home/selectUnReadMessage',
        params:params
        })
}

























































// WEBPACK FOOTER //
// ./src/api/xwwwprod.js